// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_FACET_LOCATION = "Lokalita";
export const BZ2_SHOW_PLACES_RADIUS = "Zobrazuj aj okolie 25km";
export const LOCATION_FACET_COUNTY = "okres";
